module.exports = __webpack_public_path__ + "unreal.285493.svg";